document.addEventListener('DOMContentLoaded', () => {
  document.querySelector('.service-flow__text-outer').style.maxHeight = getVisibleHeight() + 'px';
  document.querySelector('.service-flow__more--display').addEventListener('click', (event) => {
    if (!event.target.classList.contains('service-flow__more--display')) return;

    document.querySelector('.service-flow__text-outer').style.maxHeight = getInnerHeight() + 'px';

    document.querySelectorAll('.service-flow__gradient').forEach((el) => {
      el.style.display = 'none';
    });

    event.target.style.display = 'none';

    document.querySelector('.service-flow__more--hidden').style.display = 'flex';
  });

  document.querySelector('.service-flow__more--hidden').addEventListener('click', (event) => {
    if (!event.target.classList.contains('service-flow__more--hidden')) return;

    document.querySelector('.service-flow__text-outer').style.maxHeight = getVisibleHeight() + 'px';

    document.querySelectorAll('.service-flow__gradient').forEach((el) => {
      el.style.display = 'block';
    });

    event.target.style.display = 'none';

    document.querySelector('.service-flow__more--display').style.display = 'flex';
  });
});

// .service-flow__text-item の要素2つ目までの高さを取得
function getVisibleHeight() {
  const items = document.querySelectorAll('.service-flow__text-item');
  let height = 0;

  for (let i = 0; i < 2; i++) {
    height += items[i].clientHeight;
  }

  return height;
}

function getInnerHeight() {
  const item = document.querySelector('.service-flow__text-inner');
  return item.clientHeight;
}
